var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 0.5625C9.71875 0.21875 9.375 0 9 0C8.59375 0 8.25 0.21875 8.09375 0.5625L6.09375 4.71875L1.59375 5.375C1.21875 5.4375 0.90625 5.6875 0.78125 6.0625C0.6875 6.40625 0.78125 6.8125 1.03125 7.0625L4.28125 10.2812L3.53125 14.8438C3.46875 15.2188 3.625 15.5938 3.9375 15.8125C4.25 16.0625 4.65625 16.0625 4.96875 15.9062L9 13.75L13 15.9062C13.3438 16.0625 13.75 16.0625 14.0625 15.8125C14.375 15.5938 14.5312 15.2188 14.4688 14.8438L13.6875 10.2812L16.9375 7.0625C17.2188 6.8125 17.3125 6.40625 17.1875 6.0625C17.0625 5.6875 16.75 5.4375 16.375 5.375L11.9062 4.71875L9.875 0.5625Z",
    fill: "#E8C550"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.a891d93bd10d372cb0706eb8e3a0e3d2.svg";
export { ForwardRef as ReactComponent };